import { useEffect } from 'react';
import logger from 'lc-logger';
import { Grid } from '@ui-propulsion/react-components';
import appConfig from 'lc-app-config';
import csrf from '../../../services/helpers/csrf';
import render404Page from '../../../services/helpers/render404Page';
import GlossaryService from '../../../services/glossary';
import styles from '../../../styles/main.module.scss';
import glossaryStyles from '../../../styles/glossary.module.scss';
import helpStyles from '../../../styles/help.module.scss';
import GlossaryTerms from '../../../components/glossaryTerms/glossaryTerms';
import GlossaryHubPrequal from '../../../components/glossaryHubPrequal/glossaryHubPrequal';
import Breadcumbs from '../../../components/breadcrumbs/breadcrumbs';
import GlossaryNav from '../../../components/glossaryNav/glossaryNav';
import trackHeapEvent from '../../../services/helpers/trackHeapEvent';
import { getOptimizelyUserExperiments } from '../../../services/helpers/common';

export default function Page({ nav, termsList, prequal, experiments }) {
  useEffect(() => {
    trackHeapEvent(
      {
        Title: 'Page Load',
        Page: 'Glossary Letter page',
      },
      `CMS_Unification`,
      experiments
    );
  }, [experiments]);
  const isSideBarActive = prequal;
  return (
    <main className={`${styles.main} ${glossaryStyles.main}`}>
      <GlossaryNav nav={nav} />
      {termsList && (
        <div className={styles.container}>
          <div className={`${styles.section} ${glossaryStyles.section}`}>
            <Grid container>
              <Grid
                item
                xs={12}
                md={8}
                className={isSideBarActive ? helpStyles.articleLeft : ''}
              >
                <div className={helpStyles.breadcrumbs}>
                  <Breadcumbs
                    links={[{ label: 'Glossary', link: '/glossary' }]}
                  />
                </div>
                <div className={glossaryStyles.allTerms}>
                  <GlossaryTerms {...termsList} />
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={helpStyles.prequal}>
                  {prequal && <GlossaryHubPrequal {...prequal} />}
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      )}
    </main>
  );
}

export async function getServerSideProps(context) {
  const hub = `Glossary`;
  const userVariation = getOptimizelyUserExperiments(context.req.headers);

  const glossaryService = new GlossaryService(context.preview);

  const { letter } = context.params;
  const props = await glossaryService.getHomePage(
    hub,
    userVariation,
    letter.toUpperCase()
  );
  if (!props) {
    logger.info(
      {
        statusCode: 404,
        hub,
      },
      `LC-WEBSITE: Hub home page not found`
    );
    return render404Page(context);
  }
  logger.info(
    {
      statusCode: 200,
      hub,
    },
    `LC-WEBSITE: Generating home page for Hub`
  );

  const hubProps = await glossaryService.getGlossaryLetterPage(
    letter.toUpperCase()
  );
  if (!hubProps) {
    logger.info(
      {
        statusCode: 404,
        letter,
      },
      `LC-WEBSITE: Page not found for Slug`
    );
    return render404Page(context);
  }
  logger.info(
    {
      statusCode: 200,
      letter,
    },
    `LC-WEBSITE: Generating page for Slug`
  );

  const spaceId = appConfig.get('CONTENTFUL_SPACE_ID');
  const csrfToken = await csrf(context.req, context.res);
  return {
    props: {
      ...props,
      ...hubProps,
      isPreview: !!context.preview,
      spaceId,
      csrfToken,
      experiments: Object.fromEntries(userVariation),
    },
  };
}
